<ng-container [ngTemplateOutlet]="shouldRenderPreviousNoCheckIn() ? noReflection : previousCheckIn" [ngTemplateOutletContext]="{ type: 'previous' }"> </ng-container>

<ng-container [ngTemplateOutlet]="shouldRenderCurrentNoCheckIn() ? noReflection : currentCheckIn" [ngTemplateOutletContext]="{ type: 'current' }"> </ng-container>

<ng-template #previousCheckIn>
  <ng-container *ngIf="!filter || filter === 'published'">
    <cadence-label [cadenceStartDate]="prevCadenceStartDate" [attr.aria-label]="formatCadenceDates(prevCadenceStartDate)" tabindex="0"></cadence-label>
    <!-- MOOD PREV -->
    <reflection-mood
      class="previous-check-in mood-item reflection-mood-previous"
      *ngIf="shouldRenderMood(prevReflection)"
      [isEditModeEnabled]="prevReflection.isEditing"
      [reflectionMood]="prevReflection.mood"
      [attr.data-test-id]="'previous-check-in-mood'"
      (moodChange)="onMoodChange($event, 'previous')"></reflection-mood>
    <i
      class="dot-container previous-check-in"
      *ngIf="!shouldRenderMood(prevReflection) && shouldRenderMood(currReflection) && !shouldRenderCurrentNoCheckIn()"
      ui-icon
      uiTheme="fill"
      uiType="dots"></i>

    <!-- QUESTIONS PREV -->
    <ng-container *ngFor="let question of prevQuestionsFormatted; let i = index">
      <div class="previous-check-in question-item" [attr.id]="question?.answerId" [class.sp-mb-32]="question?.answer || question?.gif?.id">
        <reflection-question
          class="sp-mb-8 sp-mt-6"
          *ngIf="shouldRenderQuestion(prevReflection, question)"
          [team]="team"
          [teams]="teams"
          [question]="question"
          [isEditModeEnabled]="prevReflection.isEditing"
          [attr.data-test-id]="'previous-check-in-question-' + question.question"
          (answerUpdate)="onAnswerChange($event, 'previous')"
          (okrLinkClick)="okrLinkClick.emit($event)"></reflection-question>
        <ng-container *featureToggleEnabled="'checkins-interactions'">
          <div class="reactions-container" *ngIf="shouldRenderQuestion(prevReflection, question) && !prevReflection.isEditing">
            <reactions
              [(reactions)]="question.reactions"
              [target]="generateCommentTemplate(question.answerId, 'check-in-reaction-answer')"
              [targetParentId]="prevReflection.id"
              [attr.data-test-id]="'previous-check-in-reactions-question-' + question.question"
              targetType="check-in-reaction-answer">
              <button
                class="comments-toggle-button"
                [attr.aria-label]="'add_comment' | localize"
                (click)="onToggleComments({ status: true, type: 'previous', target: 'questions', commentParentIndex: i, targetId: question.answerId, scrollToEditor: true, source: 'addButton' })"
                ui-button>
                <i class="fs-16px" ui-icon uiType="comments"></i>
              </button>
            </reactions>
          </div>
          <div
            class="comments-overview sp-mt-6"
            *ngIf="question?.comments?.length && (question?.answer || question?.gif?.id) && !prevReflection.isEditing && question.isEnabled && !question.isCommentsEnabled">
            <ui-assignee-avatar-group class="sp-mr-8" [uiMax]="4" uiSize="xs">
              <ui-assignee-avatar *ngFor="let assignee of question.commentsAssignees" [uiAssignee]="assignee" />
            </ui-assignee-avatar-group>
            <checkin-comments-counter
              class="sp-mt-1 sp-mr-4"
              [attr.aria-label]="buildCheckinCommentsCounterAriaLabel(question.comments) + (getLatestDateFromComments(question.comments) | date : 'MMMM dd, yyyy, HH:mm' | timeAgo : 24)"
              [attr.data-test-id]="'previous-checkin-comments-counter-question-' + question.question"
              [count]="question?.comments?.length"
              (click)="onToggleComments({ status: true, type: 'previous', target: 'questions', targetId: question.answerId, commentParentIndex: i, scrollToEditor: false })"
              (keydown.enter)="onToggleComments({ status: true, type: 'previous', target: 'questions', targetId: question.answerId, commentParentIndex: i, scrollToEditor: false })"
              tabindex="0"></checkin-comments-counter>
            <checkin-latest-comment-date class="sp-mt-1" *ngIf="question?.comments?.length" [latestDate]="getLatestDateFromComments(question.comments)"></checkin-latest-comment-date>
          </div>
          <div
            class="sp-mt-12"
            *ngIf="(question?.answer || question?.gif?.id) && !prevReflection.isEditing && question.isEnabled && question.isCommentsEnabled"
            [attr.data-test-id]="'previous-check-in-comments-container-question-' + question.question">
            <checkin-hide-comments-button
              *ngIf="question?.comments?.length"
              (hideComments)="onToggleComments({ status: false, type: 'previous', target: 'questions', targetId: question.answerId, commentParentIndex: i, scrollToEditor: false })">
            </checkin-hide-comments-button>
            <div class="comments">
              <comments
                #comments
                [initialMentions]="[prevReflection.assignee.id]"
                [editorInitialText]="question.commentPendingText"
                [externalActionButtons]="comments.comments?.length === 0"
                [focusEditor]="true"
                [scrollToEditorEvent]="scrollToCommentsEditor$.asObservable()"
                [target]="{ id: question.answerId, type: 'check-in-comment-answer', targetParentId: prevReflection.id }"
                [metadata]="{ checkinId: prevReflection.id, targetType: 'checkin_comment', cadenceStart: calculatePrevCadenceStartDate(), cadenceEnd: calculatePrevCadenceEndDate() }"
                (add)="onAddComment({ comment: $event, type: 'previous', target: 'questions', commentParentIndex: i })"
                (remove)="onRemoveComment({ comment: $event, type: 'previous', target: 'questions', commentParentIndex: i })"
                (cancel)="
                  question?.comments?.length === 0 &&
                    onToggleComments({ status: false, type: 'previous', target: 'questions', commentParentIndex: i, targetId: question.answerId, scrollToEditor: false, source: 'cancelButton' })
                "
                (textChange)="onChangeCommentPendingText({ text: $event, type: 'previous', target: 'questions', commentParentIndex: i })"></comments>
            </div>
          </div>
        </ng-container>
        <i
          class="dot-container"
          *ngIf="!shouldRenderQuestion(prevReflection, question) && shouldRenderQuestion(currReflection, currQuestionsFormatted?.[i]) && !shouldRenderCurrentNoCheckIn()"
          ui-icon
          uiTheme="fill"
          uiType="dots"></i>
      </div>
    </ng-container>
  </ng-container>

  <!-- NOTES PREV -->
  <ng-container *ngFor="let note of prevReflection?.notes | filterNotes : filter; let i = index">
    <div class="previous-check-in note-item" [attr.id]="note.id" [class.sp-mb-32]="note?.text || note?.gif?.id">
      <reflection-note
        class="sp-mb-8"
        *ngIf="shouldRenderNote(prevReflection, note)"
        [team]="team"
        [teams]="teams"
        [attr.data-test-id]="'previous-check-in-note-' + note.type"
        [note]="note"
        [isEditModeEnabled]="prevReflection.isEditing && !filter"
        (noteChange)="onNoteChange($event, 'previous', i)"
        (okrLinkClick)="okrLinkClick.emit($event)"></reflection-note>
      <ng-container *featureToggleEnabled="'checkins-interactions'">
        <div class="reactions-container" *ngIf="shouldRenderNote(prevReflection, note) && !prevReflection.isEditing">
          <reactions
            [(reactions)]="note.reactions"
            [metadata]="{ checkinId: prevReflection.id, targetType: 'checkin_' + note.type, fromNoteFilter: isNoteFilterEnabled(filter) }"
            [target]="generateCommentTemplate(note.id, 'check-in-reaction-note')"
            [targetParentId]="prevReflection.id"
            [attr.data-test-id]="'previous-check-in-reactions-note-' + note.type"
            targetType="check-in-reaction-note">
            <button
              class="comments-toggle-button"
              [attr.aria-label]="'add_comment' | localize"
              (click)="
                onToggleComments({
                  status: true,
                  type: 'previous',
                  target: 'notes',
                  commentParentIndex: prevReflection.notes.indexOf(note),
                  targetId: note.id,
                  scrollToEditor: true,
                  source: 'addButton'
                })
              "
              ui-button>
              <i class="fs-16px" ui-icon uiType="comments"></i>
            </button>
          </reactions>
        </div>

        <div class="comments-overview sp-mt-6" *ngIf="note?.comments?.length && (note?.text || note?.gif?.id) && !prevReflection.isEditing && !note.isCommentsEnabled">
          <ui-assignee-avatar-group class="sp-mr-8" [uiMax]="4" uiSize="xs">
            <ui-assignee-avatar *ngFor="let assignee of note.commentsAssignees" [uiAssignee]="assignee" />
          </ui-assignee-avatar-group>
          <checkin-comments-counter
            class="sp-mt-1 sp-mr-4"
            [attr.aria-label]="buildCheckinCommentsCounterAriaLabel(note.comments) + (getLatestDateFromComments(note.comments) | date : 'MMMM dd, yyyy, HH:mm' | timeAgo : 24)"
            [attr.data-test-id]="'previous-checkin-comments-counter-note-' + note.type"
            [count]="note?.comments?.length"
            (click)="onToggleComments({ status: true, type: 'previous', target: 'notes', targetId: note.id, commentParentIndex: prevReflection.notes.indexOf(note), scrollToEditor: false })"
            (keydown.enter)="onToggleComments({ status: true, type: 'previous', target: 'notes', targetId: note.id, commentParentIndex: prevReflection.notes.indexOf(note), scrollToEditor: false })"
            tabindex="0"></checkin-comments-counter>
          <checkin-latest-comment-date class="sp-mt-1" *ngIf="note?.comments?.length" [latestDate]="getLatestDateFromComments(note.comments)"></checkin-latest-comment-date>
        </div>
        <div
          class="sp-mt-12"
          *ngIf="(note?.text || note?.gif?.id) && !prevReflection.isEditing && note.isCommentsEnabled"
          [attr.data-test-id]="'previous-check-in-comments-container-note-' + note.type">
          <checkin-hide-comments-button
            *ngIf="note?.comments?.length"
            (hideComments)="onToggleComments({ status: false, type: 'previous', target: 'notes', targetId: note.id, commentParentIndex: prevReflection.notes.indexOf(note), scrollToEditor: false })">
          </checkin-hide-comments-button>
          <div class="comments">
            <comments
              class="comments"
              #comments
              [initialMentions]="[prevReflection.assignee.id]"
              [editorInitialText]="note.commentPendingText"
              [externalActionButtons]="comments.comments?.length === 0"
              [focusEditor]="true"
              [scrollToEditorEvent]="scrollToCommentsEditor$.asObservable()"
              [target]="{ id: note.id, type: 'check-in-comment-note', targetParentId: prevReflection.id }"
              [metadata]="{
                checkinId: prevReflection.id,
                targetType: 'checkin_comment',
                cadenceStart: calculatePrevCadenceStartDate(),
                cadenceEnd: calculatePrevCadenceEndDate(),
                fromNoteFilter: isNoteFilterEnabled(filter)
              }"
              (add)="onAddComment({ comment: $event, type: 'previous', target: 'notes', commentParentIndex: prevReflection.notes.indexOf(note) })"
              (remove)="onRemoveComment({ comment: $event, type: 'previous', target: 'notes', commentParentIndex: prevReflection.notes.indexOf(note) })"
              (cancel)="
                note?.comments?.length === 0 &&
                  onToggleComments({
                    status: false,
                    type: 'previous',
                    target: 'notes',
                    commentParentIndex: prevReflection.notes.indexOf(note),
                    targetId: note.id,
                    scrollToEditor: false,
                    source: 'cancelButton'
                  })
              "
              (textChange)="onChangeCommentPendingText({ text: $event, type: 'previous', target: 'notes', commentParentIndex: prevReflection.notes.indexOf(note) })"></comments>
          </div>
        </div>
      </ng-container>
      <i
        class="dot-container previous-check-in"
        *ngIf="!shouldRenderNote(prevReflection, note) && shouldRenderNote(currReflection, currReflection.notes?.[i]) && !shouldRenderCurrentNoCheckIn()"
        ui-icon
        uiTheme="fill"
        uiType="dots"></i>
    </div>
  </ng-container>

  <!-- DOTS WHEN FILTERING -->
  <div class="previous-check-in" *ngIf="filter && !(prevReflection?.notes | filterNotes : filter)?.length">
    <i class="dot-container" ui-icon uiTheme="fill" uiType="dots"></i>
  </div>

  <!--ACTIONS-->
  <checkin-action-buttons
    class="sp-mt-8 sp-mb-8 previous-checkin-action-buttons"
    *ngIf="!filter && prevReflection.isEditable && prevReflection.isCurrentUser"
    [ngStyle]="{ 'grid-column-start': '1' }"
    [checkIn]="prevReflection"
    [isCheckInEmpty]="isReflectionEmpty(prevReflection)"
    [attr.data-test-id]="'previous-check-in-action-buttons'"
    (checkInPublish)="onPublishReflection($event)"
    (checkInEdit)="onEditReflection($event)"
    (checkInCancel)="onCancelReflection($event)"
    type="previous"></checkin-action-buttons>
</ng-template>

<ng-template #currentCheckIn>
  <ng-container *ngIf="!filter || filter === 'published'">
    <cadence-label class="current-check-in" [cadenceStartDate]="currCadenceStartDate" [attr.aria-label]="formatCadenceDates(currCadenceStartDate)" tabindex="0"></cadence-label>
    <!-- MOOD CURR -->
    <reflection-mood
      class="current-check-in reflection-mood-current"
      *ngIf="shouldRenderMood(currReflection)"
      [isEditModeEnabled]="currReflection.isEditing"
      [reflectionMood]="currReflection.mood"
      [attr.data-test-id]="'current-check-in-mood'"
      (moodChange)="onMoodChange($event, 'current')"></reflection-mood>
    <i
      class="dot-container current-check-in"
      *ngIf="!shouldRenderMood(currReflection) && shouldRenderMood(prevReflection) && !shouldRenderPreviousNoCheckIn()"
      ui-icon
      uiTheme="fill"
      uiType="dots"></i>

    <!-- QUESTIONS CURR -->
    <ng-container *ngFor="let question of currQuestionsFormatted; let i = index">
      <div class="current-check-in" [attr.id]="question?.answerId" [class.sp-mb-32]="question?.answer || question?.gif?.id">
        <reflection-question
          class="sp-mb-8 sp-mt-6"
          *ngIf="shouldRenderQuestion(currReflection, question)"
          [team]="team"
          [teams]="teams"
          [question]="question"
          [isEditModeEnabled]="currReflection.isEditing"
          [attr.data-test-id]="'current-check-in-question-' + question.question"
          (answerUpdate)="onAnswerChange($event, 'current')"
          (okrLinkClick)="okrLinkClick.emit($event)"></reflection-question>
        <ng-container *featureToggleEnabled="'checkins-interactions'">
          <div class="reactions-container" *ngIf="shouldRenderQuestion(currReflection, question) && !currReflection.isEditing">
            <reactions
              [(reactions)]="question.reactions"
              [target]="generateCommentTemplate(question.answerId, 'check-in-reaction-answer')"
              [targetParentId]="currReflection.id"
              [attr.data-test-id]="'current-check-in-reactions-question-' + question.question"
              targetType="check-in-reaction-answer">
              <button
                class="comments-toggle-button"
                [attr.aria-label]="'add_comment' | localize"
                (click)="onToggleComments({ status: true, type: 'current', target: 'questions', commentParentIndex: i, targetId: question.answerId, scrollToEditor: true, source: 'addButton' })"
                ui-button>
                <i class="fs-16px" ui-icon uiType="comments"></i>
              </button>
            </reactions>
          </div>
          <div
            class="comments-overview sp-mt-6"
            *ngIf="question?.comments?.length && (question?.answer || question?.gif?.id) && !currReflection.isEditing && question.isEnabled && !question.isCommentsEnabled">
            <ui-assignee-avatar-group class="sp-mr-8" [uiMax]="4" uiSize="xs">
              <ui-assignee-avatar *ngFor="let assignee of question.commentsAssignees" [uiAssignee]="assignee" />
            </ui-assignee-avatar-group>
            <checkin-comments-counter
              class="sp-mt-1 sp-mr-4"
              [attr.aria-label]="buildCheckinCommentsCounterAriaLabel(question.comments) + (getLatestDateFromComments(question.comments) | date : 'MMMM dd, yyyy, HH:mm' | timeAgo : 24)"
              [attr.data-test-id]="'current-checkin-comments-counter-question-' + question.question"
              [count]="question?.comments?.length"
              (click)="onToggleComments({ status: true, type: 'current', target: 'questions', targetId: question.answerId, commentParentIndex: i, scrollToEditor: false })"
              (keydown.enter)="onToggleComments({ status: true, type: 'current', target: 'questions', targetId: question.answerId, commentParentIndex: i, scrollToEditor: false })"
              tabindex="0"></checkin-comments-counter>
            <checkin-latest-comment-date class="sp-mt-1" *ngIf="question?.comments?.length" [latestDate]="getLatestDateFromComments(question.comments)"></checkin-latest-comment-date>
          </div>
          <div
            class="sp-mt-12"
            *ngIf="(question?.answer || question?.gif?.id) && !currReflection.isEditing && question.isEnabled && question.isCommentsEnabled"
            [attr.data-test-id]="'current-check-in-comments-container-question-' + question.question">
            <checkin-hide-comments-button
              *ngIf="question?.comments?.length"
              (hideComments)="onToggleComments({ status: false, type: 'current', target: 'questions', targetId: question.answerId, commentParentIndex: i, scrollToEditor: false })">
            </checkin-hide-comments-button>
            <div class="comments">
              <comments
                #comments
                [initialMentions]="[currReflection.assignee.id]"
                [editorInitialText]="question.commentPendingText"
                [externalActionButtons]="comments.comments?.length === 0"
                [focusEditor]="true"
                [scrollToEditorEvent]="scrollToCommentsEditor$.asObservable()"
                [target]="{ id: question.answerId, type: 'check-in-comment-answer', targetParentId: currReflection.id }"
                [metadata]="{ checkinId: currReflection.id, targetType: 'checkin_comment', cadenceStart: calculateCurrCadenceStartDate(), cadenceEnd: calculateCurrCadenceEndDate() }"
                (add)="onAddComment({ comment: $event, type: 'current', target: 'questions', commentParentIndex: i })"
                (remove)="onRemoveComment({ comment: $event, type: 'current', target: 'questions', commentParentIndex: i })"
                (cancel)="
                  question?.comments?.length === 0 &&
                    onToggleComments({ status: false, type: 'current', target: 'questions', commentParentIndex: i, targetId: question.answerId, scrollToEditor: false, source: 'cancelButton' })
                "
                (textChange)="onChangeCommentPendingText({ text: $event, type: 'current', target: 'questions', commentParentIndex: i })"></comments>
            </div>
          </div>
        </ng-container>
        <i
          class="dot-container current-check-in"
          *ngIf="!shouldRenderQuestion(currReflection, question) && shouldRenderQuestion(prevReflection, prevQuestionsFormatted?.[i]) && !shouldRenderPreviousNoCheckIn()"
          ui-icon
          uiTheme="fill"
          uiType="dots"></i>
      </div>
    </ng-container>
  </ng-container>

  <!-- NOTES CURR -->
  <ng-container *ngFor="let note of currReflection.notes | filterNotes : filter; let i = index">
    <div class="current-check-in" [attr.id]="note.id" [class.sp-mb-32]="note?.text || note?.gif?.id">
      <reflection-note
        class="sp-mb-8"
        *ngIf="shouldRenderNote(currReflection, note)"
        [team]="team"
        [teams]="teams"
        [attr.data-test-id]="'current-check-in-note-' + note.type"
        [note]="note"
        [isEditModeEnabled]="currReflection.isEditing && !filter"
        (noteChange)="onNoteChange($event, 'current', i)"
        (okrLinkClick)="okrLinkClick.emit($event)"></reflection-note>
      <ng-container *featureToggleEnabled="'checkins-interactions'">
        <div class="reactions-container" *ngIf="shouldRenderNote(currReflection, note) && !currReflection.isEditing">
          <reactions
            [(reactions)]="note.reactions"
            [target]="generateCommentTemplate(note.id, 'check-in-reaction-note')"
            [targetParentId]="currReflection.id"
            [metadata]="{ checkinId: currReflection.id, targetType: 'checkin_' + note.type, fromNoteFilter: isNoteFilterEnabled(filter) }"
            [attr.data-test-id]="'current-check-in-reactions-note-' + note.type"
            targetType="check-in-reaction-note">
            <button
              class="comments-toggle-button"
              [attr.aria-label]="'add_comment' | localize"
              (click)="
                onToggleComments({
                  status: true,
                  type: 'current',
                  target: 'notes',
                  commentParentIndex: currReflection.notes.indexOf(note),
                  targetId: note.id,
                  scrollToEditor: true,
                  source: 'addButton'
                })
              "
              ui-button>
              <i class="fs-16px" ui-icon uiType="comments"></i>
            </button>
          </reactions>
        </div>
        <div class="comments-overview sp-mt-6" *ngIf="note?.comments?.length && (note?.text || note?.gif?.id) && !currReflection.isEditing && !note.isCommentsEnabled">
          <ui-assignee-avatar-group class="sp-mr-8" [uiMax]="4" uiSize="xs">
            <ui-assignee-avatar *ngFor="let assignee of note.commentsAssignees" [uiAssignee]="assignee" />
          </ui-assignee-avatar-group>
          <checkin-comments-counter
            class="sp-mt-1 sp-mr-4"
            [attr.aria-label]="buildCheckinCommentsCounterAriaLabel(note.comments) + (getLatestDateFromComments(note.comments) | date : 'MMMM dd, yyyy, HH:mm' | timeAgo : 24)"
            [attr.data-test-id]="'current-checkin-comments-counter-note-' + note.type"
            [count]="note?.comments?.length"
            (click)="onToggleComments({ status: true, type: 'current', target: 'notes', targetId: note.id, commentParentIndex: currReflection.notes.indexOf(note), scrollToEditor: false })"
            (keydown.enter)="onToggleComments({ status: true, type: 'current', target: 'notes', targetId: note.id, commentParentIndex: currReflection.notes.indexOf(note), scrollToEditor: false })"
            tabindex="0"></checkin-comments-counter>
          <checkin-latest-comment-date class="sp-mt-1" *ngIf="note?.comments?.length" [latestDate]="getLatestDateFromComments(note.comments)"></checkin-latest-comment-date>
        </div>
        <div
          class="sp-mt-12"
          *ngIf="(note?.text || note?.gif?.id) && !currReflection.isEditing && note.isCommentsEnabled"
          [attr.data-test-id]="'current-check-in-comments-container-note-' + note.type">
          <checkin-hide-comments-button
            *ngIf="note?.comments?.length"
            (hideComments)="onToggleComments({ status: false, type: 'current', target: 'notes', targetId: note.id, commentParentIndex: currReflection.notes.indexOf(note), scrollToEditor: false })">
          </checkin-hide-comments-button>
          <div class="comments">
            <comments
              #comments
              [initialMentions]="[currReflection.assignee.id]"
              [editorInitialText]="note.commentPendingText"
              [externalActionButtons]="comments.comments?.length === 0"
              [focusEditor]="true"
              [scrollToEditorEvent]="scrollToCommentsEditor$.asObservable()"
              [target]="{ id: note.id, type: 'check-in-comment-note', targetParentId: currReflection.id }"
              [metadata]="{
                checkinId: currReflection.id,
                targetType: 'checkin_comment',
                cadenceStart: calculateCurrCadenceStartDate(),
                cadenceEnd: calculateCurrCadenceEndDate(),
                fromNoteFilter: isNoteFilterEnabled(filter)
              }"
              (add)="onAddComment({ comment: $event, type: 'current', target: 'notes', commentParentIndex: currReflection.notes.indexOf(note) })"
              (remove)="onRemoveComment({ comment: $event, type: 'current', target: 'notes', commentParentIndex: currReflection.notes.indexOf(note) })"
              (cancel)="
                note?.comments?.length === 0 &&
                  onToggleComments({
                    status: false,
                    type: 'current',
                    target: 'notes',
                    commentParentIndex: currReflection.notes.indexOf(note),
                    targetId: note.id,
                    scrollToEditor: false,
                    source: 'cancelButton'
                  })
              "
              (textChange)="onChangeCommentPendingText({ text: $event, type: 'current', target: 'notes', commentParentIndex: currReflection.notes.indexOf(note) })"></comments>
          </div>
        </div>
      </ng-container>
      <i
        class="dot-container current-check-in"
        *ngIf="!shouldRenderNote(currReflection, note) && shouldRenderNote(prevReflection, prevReflection.notes?.[i]) && !shouldRenderPreviousNoCheckIn()"
        ui-icon
        uiTheme="fill"
        uiType="dots"></i>
    </div>
  </ng-container>

  <!--DOTS WHEN FILTERING FILTERING-->
  <div class="current-check-in" *ngIf="filter && !(currReflection.notes | filterNotes : filter).length">
    <i class="dot-container" ui-icon uiTheme="fill" uiType="dots"></i>
  </div>

  <!--ACTIONS-->

  <checkin-action-buttons
    class="sp-mt-8"
    *ngIf="!filter && currReflection.isEditable && currReflection.isCurrentUser"
    [ngStyle]="{ 'grid-column-start': '2' }"
    [checkIn]="currReflection"
    [isCheckInEmpty]="isReflectionEmpty(currReflection)"
    [attr.data-test-id]="'current-check-in-action-buttons'"
    (checkInPublish)="onPublishReflection($event)"
    (checkInEdit)="onEditReflection($event)"
    (checkInCancel)="onCancelReflection($event)"
    type="current"></checkin-action-buttons>
</ng-template>

<ng-template #noReflection let-type="type">
  <cadence-label
    *ngIf="!filter"
    [attr.aria-label]="formatCadenceDates(currCadenceStartDate) + ' ' + ('check_ins_no_check_in' | localize)"
    [ngStyle]="{ 'grid-column-start': type === 'current' ? 2 : 1 }"
    [cadenceStartDate]="type === 'current' ? currCadenceStartDate : prevCadenceStartDate"
    tabindex="0"></cadence-label>
  <div class="no-reflection" [ngStyle]="{ 'grid-column-start': type === 'current' ? 2 : 1 }">
    <span>{{ "check_ins_no_check_in" | localize }}</span>
    <button
      class="sp-mt-16"
      *ngIf="((type === 'current' && currReflection?.isCurrentUser && currReflection?.isEditable) || (type === 'previous' && prevReflection?.isCurrentUser && prevReflection?.isEditable)) && !filter"
      [attr.data-test-id]="'check-in-fillout-btn'"
      (click)="onFillOutReflection(type)"
      ui-button
      uiShape="round"
      uiType="default"
      uiSize="large">
      {{ "reflections_fill_out" | localize }}
    </button>
  </div>
</ng-template>
